import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import qs from 'qs'

const BreederState = State({
  initial: {
    key: null,
    horses: [],
    horsePage: null,
    details: null
  },
  setBreederHorse (state, payload) {
    return {
      key: payload.key,
      horses: payload.horses,
      horsePage: payload.page
    }
  },
  setBreederDetails (state, payload) {
    return {
      ...state,
      details: payload.details,
      key: payload.key
    }
  }
})

// eslint-disable-next-line
const horseSetBreederEffect = Effect('horseSetBreeder', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}horse/set-breeder`, params)
})

// eslint-disable-next-line
const loadBreedersHorseEffect = Effect('loadBreedersHorse', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({key: params.term, page: params.page})
  return axios.get(`${apiAddress}horse/breeder${urlParams}`).then((res) => {
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const loadBreederDetailsEffect = Effect('loadBreederDetails', (term) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({key: term})
  return axios.get(`${apiAddress}horse/breeder-info${urlParams}`).then((res) => {
    Actions.setBreederDetails({key: term, details: res.data})
    return res
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const loadBreederHorseAndDetailsEffect = Effect('loadBreederHorseAndDetails', (params) => {
  return Promise.resolve().then(() => {
    Actions.loadBreedersHorse(params).then((res) => Actions.setBreederHorse({key: params.term, horses: res.data, page: params.page}))
  }).then(() => {
    Actions.loadBreederDetails(params.term)
  }).catch((e) => { console.log(e); Promise.reject(e) })
})

export default BreederState



// WEBPACK FOOTER //
// ./src/states/breeder.js